/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2023-12-29 14:31:13
 * @LastEditors: sueRimn
 * @LastEditTime: 2024-09-03 17:10:00
 */
export const CURRENCY_MAP = {
  USD: { text: '美元', val: 'USD', unit: '$' },
  CNY: { text: '人民币', val: 'CNY', unit: '¥' }
}
export enum CHANNEL_TYPE_ENUM {
  LOG = 1,
  MEMO = 2,
  PROJECT = 3,
  PIPELINE = 4,
  PORTFOLIO = 5
}

export const CHANNEL_TYPE = {
  [CHANNEL_TYPE_ENUM.LOG]: 'Log',
  [CHANNEL_TYPE_ENUM.MEMO]: 'Memo',
  [CHANNEL_TYPE_ENUM.PROJECT]: '项目',
  [CHANNEL_TYPE_ENUM.PIPELINE]: 'Pipeline',
  [CHANNEL_TYPE_ENUM.PORTFOLIO]: 'Portfolio'
}
// V1.9.0 目前有：Victor，Ted，Peter（共3位）
export const SECTOR_LEADERS = [
  { key: 33, value: 'Victor' },
  { key: 15, value: 'Ted' },
  { key: 2, value: 'Peter' }
]

export enum Types {
  USER = 'USER',
  TEAM = 'TEAM'
}
export enum YesOrNo {
  Yes = 1, //是
  No = 2, //否
}
export const YesOrNoText = {
  [YesOrNo.Yes]: '是',
  [YesOrNo.No]: '否',
};
